import React from 'react';

const MarketplaceFlow = ({ className = "w-full h-64" }) => {
  return (
    <svg 
      className={className}
      viewBox="0 0 800 250" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs>
        <linearGradient id="flowGradient" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#8B5CF6" />
          <stop offset="100%" stopColor="#EC4899" />
        </linearGradient>
        <filter id="flowGlow">
          <feGaussianBlur stdDeviation="3" result="coloredBlur"/>
          <feMerge> 
            <feMergeNode in="coloredBlur"/>
            <feMergeNode in="SourceGraphic"/>
          </feMerge>
        </filter>
      </defs>
      
      {/* Creator Section */}
      <g className="animate-bounce" style={{animationDuration: '2s'}}>
        <rect x="50" y="100" width="100" height="80" rx="15" fill="#1F2937" stroke="#8B5CF6" strokeWidth="2" />
        <circle cx="100" cy="130" r="15" fill="url(#flowGradient)" filter="url(#flowGlow)" />
        <text x="100" y="160" textAnchor="middle" className="fill-white text-sm font-semibold">Creator</text>
        <text x="100" y="175" textAnchor="middle" className="fill-gray-400 text-xs">Mints NFT</text>
      </g>
      
      {/* Arrow 1 */}
      <path d="M150 140 L 200 140" stroke="#8B5CF6" strokeWidth="4" markerEnd="url(#arrowhead)" className="animate-pulse" />
      <circle cx="175" cy="140" r="3" fill="#8B5CF6" className="animate-ping" />
      
      {/* Marketplace Section */}
      <g className="animate-bounce" style={{animationDuration: '2s', animationDelay: '0.5s'}}>
        <rect x="250" y="80" width="120" height="120" rx="20" fill="#1F2937" stroke="#EC4899" strokeWidth="3" />
        <rect x="270" y="100" width="80" height="60" rx="10" fill="#374151" />
        <circle cx="310" cy="130" r="20" fill="url(#flowGradient)" filter="url(#flowGlow)" />
        <text x="310" y="160" textAnchor="middle" className="fill-white text-sm font-semibold">Marketplace</text>
        <text x="310" y="175" textAnchor="middle" className="fill-gray-400 text-xs">Lists & Trades</text>
      </g>
      
      {/* Arrow 2 */}
      <path d="M370 140 L 420 140" stroke="#EC4899" strokeWidth="4" markerEnd="url(#arrowhead)" className="animate-pulse" style={{animationDelay: '0.3s'}} />
      <circle cx="395" cy="140" r="3" fill="#EC4899" className="animate-ping" style={{animationDelay: '0.3s'}} />
      
      {/* Collector Section */}
      <g className="animate-bounce" style={{animationDuration: '2s', animationDelay: '1s'}}>
        <rect x="470" y="100" width="100" height="80" rx="15" fill="#1F2937" stroke="#F59E0B" strokeWidth="2" />
        <circle cx="520" cy="130" r="15" fill="url(#flowGradient)" filter="url(#flowGlow)" />
        <text x="520" y="160" textAnchor="middle" className="fill-white text-sm font-semibold">Collector</text>
        <text x="520" y="175" textAnchor="middle" className="fill-gray-400 text-xs">Buys NFT</text>
      </g>
      
      {/* Money Flow */}
      <g className="animate-pulse">
        <path d="M520 100 Q 400 50 310 80" stroke="#10B981" strokeWidth="3" fill="none" opacity="0.8" />
        <circle cx="415" cy="65" r="4" fill="#10B981" className="animate-ping" />
        <text x="400" y="45" textAnchor="middle" className="fill-green-400 text-xs font-semibold">Payment</text>
      </g>
      
      {/* Royalty Flow */}
      <g className="animate-pulse" style={{animationDelay: '0.5s'}}>
        <path d="M310 200 Q 200 220 100 190" stroke="#F59E0B" strokeWidth="3" fill="none" opacity="0.8" />
        <circle cx="205" cy="205" r="4" fill="#F59E0B" className="animate-ping" style={{animationDelay: '0.5s'}} />
        <text x="200" y="240" textAnchor="middle" className="fill-yellow-400 text-xs font-semibold">Royalty</text>
      </g>
      
      {/* Arrow Marker Definition */}
      <defs>
        <marker id="arrowhead" markerWidth="10" markerHeight="7" refX="9" refY="3.5" orient="auto">
          <polygon points="0 0, 10 3.5, 0 7" fill="#8B5CF6" />
        </marker>
      </defs>
      
      {/* Floating Coins */}
      <g className="animate-bounce" style={{animationDuration: '3s'}}>
        <circle cx="150" cy="50" r="8" fill="#F59E0B" />
        <text x="150" y="55" textAnchor="middle" className="fill-white text-xs font-bold">$</text>
      </g>
      
      <g className="animate-bounce" style={{animationDuration: '3s', animationDelay: '1s'}}>
        <circle cx="400" cy="30" r="8" fill="#10B981" />
        <text x="400" y="35" textAnchor="middle" className="fill-white text-xs font-bold">₿</text>
      </g>
      
      <g className="animate-bounce" style={{animationDuration: '3s', animationDelay: '2s'}}>
        <circle cx="600" cy="40" r="8" fill="#8B5CF6" />
        <text x="600" y="45" textAnchor="middle" className="fill-white text-xs font-bold">S</text>
      </g>
    </svg>
  );
};

export default MarketplaceFlow;
